import { CONFIG_DEFAULTS } from './config-defaults';
import { versions } from './versions';
import { MediaQueryService } from '../utils/services/media-query.service';

export default async (): Promise<void> => {
  const SharedMediaQueryService = new MediaQueryService(window);

  if (window.workbench) {
    window.workbench = { ...CONFIG_DEFAULTS, ...window.workbench };
  } else {
    window.workbench = { ...CONFIG_DEFAULTS };
  }

  window.workbench.instances.push(versions);
  SharedMediaQueryService.observe();
};
